@if (rmaSummaryDatasource) {
  <div class="padlayout">
    <div
      row-layout
      [fullWidth]="true"
      justifyContent="space-between"
      alignItems="center"
      class="summary-header-row"
    >
      <Text role="headline-large">Summary</Text>
      <button
        type="button"
        text-button
        variant="primary"
        size="md"
        routerLink="/rma-management/create"
      >
        + Create New RMA
      </button>
    </div>

    <DataTable [datasource]="rmaSummaryDatasource" [columns]="rmaSummaryColumns">
    <div ngProjectAs="data-table-header" stack-layout gap="md">
      <div row-layout justifyContent="space-between" alignItems="center" [fullWidth]="true">
        <div>
          <div>
            <Text role="headline-small">Search RMA</Text>
          </div>
          <div>
            <Text role="body-medium" color="on-background-variant">
              View and manage open RMAs, search records, and create new RMAs.
            </Text>
          </div>
        </div>
      </div>

      <div
        grid-layout
        gap="md"
        [fullWidth]="true"
        templateColumns="repeat(auto-fit, minmax(310px, 1fr))"
      >
        <div>
          <div row-layout gap="sm">
            <div box-layout [grow]="1">
              <div box-layout paddingLeft="sm">
                <Text role="headline-small">Created Start Date</Text>
              </div>

              <app-input
                [form]="searchForm"
                controlName="startDate"
                type="date"
                [max]="getTodaysDate()"
              />
            </div>

            <div box-layout [grow]="1">
              <div box-layout paddingLeft="sm">
                <Text role="headline-small">Created End Date</Text>
              </div>
              <app-input
                [form]="searchForm"
                controlName="endDate"
                type="date"
                [min]="endDateMinValue()"
                [max]="getTodaysDate()"
              />
            </div>
          </div>
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">RMA Number</Text>
          </div>
          <app-input [form]="searchForm" controlName="rmaNumber" />
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">RMA Type</Text>
          </div>
          <form [formGroup]="searchForm">
            <app-multi-select-dropdown [options]="selectOptions" [enableAll]="true" formControlName="rmaType" />
          </form>
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">RMA Status</Text>
          </div>
          <form [formGroup]="searchForm">
            <app-multi-select-dropdown [options]="rmaStatusOptions" [enableAll]="true" formControlName="rmaStatus" />
          </form>
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">Order Number</Text>
          </div>
          <app-input [form]="searchForm" controlName="orderNumber" />
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">Channel</Text>
          </div>
          <form [formGroup]="searchForm">
            <app-multi-select-dropdown [options]="channelOptions()" [enableAll]="true" formControlName="channel" />
          </form>
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">Compliance</Text>
          </div>
          <form [formGroup]="searchForm">
            <app-multi-select-dropdown [options]="complianceOptions" [enableAll]="true" formControlName="compliance" />
          </form>
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">DCC</Text>
          </div>
          <form [formGroup]="searchForm">
            <app-multi-select-dropdown [options]="dccOptions()" [enableAll]="true" formControlName="dcc" />
          </form>
        </div>

        <div>
          <div box-layout paddingLeft="sm">
            <Text role="headline-small">Warehouse Code</Text>
          </div>
          <form [formGroup]="searchForm">
            <app-multi-select-dropdown [options]="warehouseOptions()" [enableAll]="true" formControlName="warehouseCode" />
          </form>
        </div>
      </div>

      <div grid-layout [fullWidth]="true">
        <div row-layout justifyContent="end" gap="md">
          <button text-button variant="primary" size="md" (click)="searchRmas()">
            Search
          </button>
          <button text-button variant="ghost" size="md" (click)="resetSearch()">
            Reset search
          </button>
        </div>
      </div>

      <Divider border="medium" />

      <div stack-layout gap="xs" paddingBottom="sm">
        <div box-layout paddingLeft="sm">
          <Text role="headline-small">RMA Status</Text>
        </div>
        <div class="rma-status-tiles-grid">
          @for (tile of statusTiles; track tile.key) {
            <div
              role="button"
              [attr.tabindex]="isStatusTileDisabled(tile.key) ? -1 : 0"
              class="rma-status-tile"
              [attr.data-status]="tile.key"
              [attr.aria-disabled]="isStatusTileDisabled(tile.key)"
              [class.rma-status-tile--active]="activeStatusTile() === tile.key"
              [class.rma-status-tile--disabled]="isStatusTileDisabled(tile.key)"
              (click)="!isStatusTileDisabled(tile.key) && applyStatusTileFilter(tile.key)"
              (keydown.enter)="!isStatusTileDisabled(tile.key) && applyStatusTileFilter(tile.key)"
              (keydown.space)="!isStatusTileDisabled(tile.key) && applyStatusTileFilter(tile.key)"
            >
              <span class="rma-status-tile__icon" aria-hidden="true">
                <Symbol
                  [name]="getStatusTileIcon(tile.key)"
                  class="rma-status-tile__icon-symbol"
                />
              </span>
              <span class="rma-status-tile__content">
                <span class="rma-status-tile__label">{{ tile.label }}</span>
                <span class="rma-status-tile__count">{{ getStatusTileCount(tile.key) }}</span>
              </span>
            </div>
          }
        </div>
      </div>
    </div>

    <div ngProjectAs="data-table-footer" stack-layout gap="md">
      <div grid-layout>
        <div row-layout justifyContent="space-between">
          <Text>{{ rmaSummaryDatasource.recordCount() }} RMAs Found</Text>
          <Paginator [datasource]="rmaSummaryDatasource" [initPageSize]="10" />
          <div></div>
        </div>
      </div>
    </div>
    </DataTable>
  </div>
}

<ng-template #rmaNumberCell let-rmaNumber="rmaNumber" let-rmaId="rmaId">
  <a class="rma-id-link" href="" (click)="$event.preventDefault(); openRmaDetails(rmaId)">
    {{ rmaNumber }}
  </a>
</ng-template>

<ng-template #statusCell let-status="status">
  <span [class]="getStatusClass(status)">{{ status || '-' }}</span>
</ng-template>

<ng-template #complianceCell let-compliance="compliance">
  <span [class]="getComplianceClass(compliance)">{{ compliance || '-' }}</span>
</ng-template>
